import { Helmet } from "react-helmet-async";

export default function Seo({ title, description, robots = "index,follow", canonical, jsonLd }) {
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {robots && <meta name="robots" content={robots} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="website" />
      {jsonLd && (
        <script type="application/ld+json">
          {typeof jsonLd === "string" ? jsonLd : JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
